/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { Avatar, AvatarProps } from '@mantine/core'

export function getUserLetters (name: string) {
  let result = ''
  if (name != null) {
    if (name.includes(' ')) {
      result = name.split(/ +/).map((v) => v.substring(0, 1)).join()
    } else {
      result = name.substring(0, 2)
    }
  }
  return result
}

export type UserAvatarProps = AvatarProps & {
  name: string
}

function UserAvatar (props: UserAvatarProps) {
  const { name, ...others } = props
  return (
    <Avatar tt="capitalize" {...others}>
      {getUserLetters(name)}
    </Avatar>
  )
}

export default UserAvatar
